export default "__VITE_ASSET__rTLFC4pC__"